import { SecondaryButton } from 'common/button'
import styled from 'styled-components'
import { EXPERIMENT_ID } from 'lib/constants'
import { useRouter } from 'next/router'
import SubscriptionPayment from './original-subscription-payment'
import SecurePayment from './secure-payment'
import FullSubscription from './full-subscription'
import SinglePrice from './single-price'

const PricingVariantsStyled = styled.div`
  .options {
    text-align: center;
    display: block;
    margin: 16px;
    font: var(--buttonRegular);
    color: var(--secondary);
    text-decoration: underline;
  }
  .buy-course {
    margin-block-start: 16px;
    .price {
      font: var(--headline4);
    }
  }
  .price {
    color: var(--baseSecondary);
    font: var(--headline5);
  }
  .price-container {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .pricing-status {
    margin: 16px 0;
  }
  .original-price {
    font: var(--regular);
    text-decoration: line-through;
    color: var(--neutral40);
    margin-left: 8px;
  }
  @media (min-width: 768px) {
    .buy-course .price {
      font: var(--headline3);
    }
  }
  @media (min-width: 1024px) {
    .buy-course .price {
      font: var(--headline4);
    }
    .pricing-status {
      margin: 16px 0 24px;
    }
  }
  @media (min-width: 1100px) {
    .buy-course .price {
      font: var(--headline3);
    }
  }
`

function PricingVariants() {
  const { query: { variant: variant_page } } = useRouter()
  const [experiment, variant_id, country] = variant_page ? variant_page.split('.') : []
  const variant = `${experiment}.${variant_id}`

  return (
    <PricingVariantsStyled>
      {/* {variant === `${EXPERIMENT_ID}.0` || !variant_page ? (
        <div id="original-subscription">
          <SubscriptionPayment />
        </div>
      ) : null} */}
      {variant === `${EXPERIMENT_ID}.1` ? (
        <SinglePrice />
      ) : null}
      {variant === `${EXPERIMENT_ID}.2` || !variant_page ? (
        <div id="see-prices" className="see-prices">
          <SecondaryButton as="a" href="#comprar" id="see-prices-btn" fullWidth>
            Ver opciones de pago
          </SecondaryButton>
        </div>
      ) : null}
      {/* {variant === `${EXPERIMENT_ID}.3` ? (
        <div id="full-subscription" className="full-subscription">
          <FullSubscription />
        </div>
      ) : null} */}
      <SecurePayment />
    </PricingVariantsStyled>
  )
}

export default PricingVariants
